import { apiDeleteQuestion } from 'core/api';
import { useStableCallback } from 'core/hooks/useStableCallback';

export default function useQuestionsApi(
  setQuestions: (fn: (prev: TQuestion[]) => TQuestion[]) => void
) {
  const onChangeQuestion = useStableCallback((updQuestion: TQuestion) => {
    setQuestions(prevQuestions =>
      prevQuestions.map(question =>
        question.uid === updQuestion.uid ? updQuestion : question
      )
    );
  });

  const onAddQuestion = useStableCallback((addQuestion: TQuestion) => {
    setQuestions(prevQuestions => [addQuestion, ...prevQuestions]);
  });

  const onRemoveQuestion = useStableCallback(async (questionUid: string) => {
    await apiDeleteQuestion(questionUid);
    setQuestions(prevQuestions =>
      prevQuestions.filter(question => question.uid !== questionUid)
    );
  });

  return {
    onChangeQuestion,
    onAddQuestion,
    onRemoveQuestion,
  };
}
